import { useQuery } from '@apollo/client';
import { Background, Button, Text } from '@do/walrus';
import React, { ReactElement } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import defaultBg from '../assets/backgrounds/Login_Default.jpg';
import newBrandBg from '../assets/backgrounds/new-brand-bg.png';
import copy from '../copy';
import { GetPasswordResetInfo } from '../generated-types/GetPasswordResetInfo';
import useDocumentTitle from '../hooks/use-document-title';
import { GET_PASSWORD_RESET_FORM_DATA } from '../queries/queries';
import { FormWrap, Loading, PaddedContents, Wrap } from './Common';
import Header from './Header';
import PasswordResetForm from './PasswordResetForm';
import NewButton from './newBrandDesign/Button';
import NewFormWrap from './newBrandDesign/FormWrap';
import NewText from './newBrandDesign/Text';
import NewTitle from './newBrandDesign/Title';

const Title = styled.h4``;

function PasswordReset({
  isNewBrandDesignEnabled = false
}: {
  isNewBrandDesignEnabled?: boolean;
}): ReactElement {
  const TitleComponent = isNewBrandDesignEnabled ? NewTitle : Title;
  const TextComponent = isNewBrandDesignEnabled ? NewText : Text;
  const ButtonComponent = isNewBrandDesignEnabled ? NewButton : Button;
  const WrapFormComponent = isNewBrandDesignEnabled ? NewFormWrap : FormWrap;

  const { token = '' } = useParams();

  const { loading: isLoading, error } = useQuery<GetPasswordResetInfo>(
    GET_PASSWORD_RESET_FORM_DATA,
    {
      variables: {
        token
      }
    }
  );

  const navigate = useNavigate();

  useDocumentTitle(copy.form.password_reset_title);

  if (isLoading) {
    return <Loading isLogin={true} />;
  }

  return (
    <>
      <Header isLogin={true} />
      <Background url={isNewBrandDesignEnabled ? newBrandBg : defaultBg} />
      <Wrap>
        <WrapFormComponent>
          <PaddedContents>
            <TitleComponent>
              {!error
                ? copy.form.password_reset.title
                : copy.form.password_reset.error_title}
            </TitleComponent>
            <TextComponent>
              {!error
                ? copy.form.password_reset.details
                : copy.form.password_reset.error_details}
            </TextComponent>
            {!error ? (
              <PasswordResetForm
                token={token}
                isNewBrandDesignEnabled={isNewBrandDesignEnabled}
              />
            ) : (
              <ButtonComponent
                onClick={() => navigate('/forgot_password/new')}
                fullWidth
              >
                {copy.form.password_reset.button_text}
              </ButtonComponent>
            )}
          </PaddedContents>
        </WrapFormComponent>
      </Wrap>
    </>
  );
}

export default PasswordReset;
